<app-tpl-form
  title="{{ isEdit ? 'APPLICATIONS.BTNS.UPDATE_CLIENT' : 'APPLICATIONS.BTNS.CREATE_CLIENT' }}"
  (cancel)="resetForm()"
  (save)="save()"
  [saveDisabled]="!form.valid"
>
  <form [formGroup]="form">
    <div class="row">
      <div class="space-v-xl column">
        <mat-card class="form-card">
          <mat-card-header class="form-card-header">
            <mat-card-title class="form-card-header-txt">{{ 'APPLICATIONS.TITLE' | translate }}</mat-card-title>
          </mat-card-header>
          <mat-card-content class="form-card-content">
            <mat-form-field class="form-field-l">
              <mat-label>{{ 'APPLICATIONS.APIKEY' | translate }}</mat-label>
              <input matInput formControlName="apikey" />
              <div matSuffix (click)="$event.stopPropagation()" style="width: 45px" *ngIf="isEdit">
                <button
                  class="cursor"
                  role="button"
                  (cdkCopyToClipboardCopied)="notifyCopy($event)"
                  [cdkCopyToClipboard]="form.controls.apikey.value"
                  matTooltip="{{ 'APPLICATIONS.LIST.COPY_BTN_TOOLTIP' | translate }}"
                >
                  <i class="fa fa-copy"></i>
                </button>
              </div>
            </mat-form-field>

            <mat-form-field class="form-field-maxi">
              <mat-label>{{ 'APPLICATIONS.NAME' | translate }}</mat-label>
              <input matInput formControlName="name" required />
            </mat-form-field>

            <mat-form-field class="form-field-m">
              <mat-label>{{ 'APPLICATIONS.NATURE' | translate }}</mat-label>
              <mat-select formControlName="nature" required [disabled]="isEdit">
                <mat-option [value]="null"></mat-option>
                <mat-option *ngFor="let nature of natureList" [value]="nature.key">
                  {{ nature.translatedName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="form-field-m">
              <mat-label>{{ 'APPLICATIONS.APPLICATION' | translate }}</mat-label>
              <mat-select formControlName="application">
                <mat-option [value]="null"></mat-option>
                <mat-option *ngFor="let application of applicationList" [value]="application.key">
                  {{ application.translatedName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="form-field-m">
              <mat-label>{{ 'APPLICATIONS.BRAND' | translate }}</mat-label>
              <mat-select formControlName="brand">
                <mat-option [value]="null">{{ 'APPLICATIONS.UNBRANDED' | translate }}</mat-option>
                <mat-option *ngFor="let brand of brands" [value]="brand.key">
                  {{ brand.translatedName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="form-field-maxi">
              <mat-label>{{ 'APPLICATIONS.FIREBASE' | translate }}</mat-label>
              <input matInput formControlName="firebaseId" />
            </mat-form-field>

            <mat-form-field class="form-field-maxi">
              <mat-label>{{ 'APPLICATIONS.CLIENT_ID' | translate }}</mat-label>
              <input matInput formControlName="clientId" />
              <div matSuffix (click)="$event.stopPropagation()" style="width: 45px">
                <button
                  class="cursor"
                  role="button"
                  (cdkCopyToClipboardCopied)="notifyCopy($event)"
                  [cdkCopyToClipboard]="form.controls.clientId.value"
                  matTooltip="{{ 'APPLICATIONS.LIST.COPY_BTN_TOOLTIP' | translate }}"
                >
                  <i class="fa fa-copy"></i>
                </button>
              </div>
            </mat-form-field>

            <app-form-field-select-autocomplete
              class="form-field-maxi"
              [label]="'APPLICATIONS.ROLES'"
              [control]="form.controls.roles"
              [useKeyAndName]="true"
              [showBracket]="false"
              [completeList]="roleList"
            ></app-form-field-select-autocomplete>

            <div class="form-field-s" *ngIf="form.controls.currentVersion.value">
              <span class="mat-form-field-label">{{ 'APPLICATIONS.DEFAULT_VERSION' | translate }}</span>
              <mat-chip-set disabled="true">
                <mat-chip>{{ form.controls.currentVersion.value }}</mat-chip>
              </mat-chip-set>
            </div>

            <mat-form-field class="form-field-maxi">
              <mat-label>{{ 'APPLICATIONS.APIM_URL' | translate }}</mat-label>
              <input matInput formControlName="apimUrl" />
            </mat-form-field>

            <mat-form-field class="form-field-maxi">
              <mat-label>{{ 'APPLICATIONS.APIM_SUBSCRIPTION_KEY' | translate }}</mat-label>
              <input matInput formControlName="apimSubscriptionKey" />
            </mat-form-field>

            <mat-form-field class="form-field-maxi">
              <mat-label>{{ 'APPLICATIONS.APIM_ALT_SUBSCRIPTION_KEY' | translate }}</mat-label>
              <input matInput formControlName="apimAltSubscriptionKey" />
            </mat-form-field>
          </mat-card-content>
        </mat-card>
        <app-clients-versions-form
          [form]="form"
          [displayedVersion]="form.controls.currentVersion.value"
          [allRestrictedFields]="allRestrictedFields"
          *ngIf="isEdit"
        ></app-clients-versions-form>
      </div>
    </div>
  </form>
</app-tpl-form>
